<template>
  <el-dialog
    :visible="visible"
    width="30%"
    @close="cancel"
    destroy-on-close
    title="订单发货"
    custom-class="customModal">
    <AppForm
      v-if="visible"
      ref="form"
      formStyle="default"
      :fields="formFields"
      :rules="rules"
      @cancel="cancel"
      @submit="submit"
      />
  </el-dialog>
</template>

<script>
import { OrderService } from '../../service/order.service';
  export default {
    name: 'delivery',
    data() {
      return {
        visible: false,
        openType: '',
        rules: {
//          shipping_info: [{ type: 'array', required: true, message: '请至少选择一个商品', trigger: 'change'}],
          shipping_sn: [{ required: true, message: '请填写单号'}],
          shipping_code: [{ required: true, message: '请选择物流公司'}],
        },
        formFields: [
//          { type: 'checkbox', key: 'shipping_info', label: '商品', span: 24},
          { type: 'select', key: 'shipping_code', label: '物流公司', span: 24 },
          { type: 'input', key: 'shipping_sn', label: '物流单号', span: 24 },
        ],
        orderData: {},
        shipData: [],
//        formValue: { shipping_info: []}
      }
    },
    async created() {
      await OrderService.shippList({ page: 1, rows: 99999 }).then((res)=>{
        this.shipData = res.data;
        this.formFields[0].options = res.data;
        res.data.forEach(item => {
          item.label = item.shipping_name;
          item.value = item.shipping_id;
        });
        this.formFields = [...this.formFields]
      });
    },
    methods: {
      open(data/*, orderList*/) {
//        this.formFields[0].options = orderList;
        this.visible = true;
        this.orderData = data;
      },
      cancel() {
        this.visible = false;
      },
      async submit(data) {
        const shipping_name = (this.shipData.find(item => item.value === data.shipping_code) || {}).shipping_name;
        await OrderService.send({...data, shipping_name, order_id: this.orderData.order_id})
        this.cancel();
        this.$emit('success');
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>